<script>
import { MeanChart } from "@/redem/datafiles/result-charts.js";
import DatafileReportService from "@/api/services/datafileReport.service.js";
import { GLOBALS } from "@/shared/util/globals.js";

export default {
  props: {
    datafileId: String
  },
  data() {
    return {
      meanChartOptions: null,
      chartDataForCleanedCertaintyScoreMeanChart: 0,
      chartDataForRawCertaintyScoreMeanChart: 0
    };
  },
  async created() {
    await this.fetchChartData();
    this.meanChartOptions = new MeanChart();
  },
  methods: {
    async fetchChartData() {
      const cScores = await DatafileReportService.getReportAverageCertaintyScore(
        this.datafileId,
        GLOBALS.reportPassword
      );
      this.$emit("finishLoading");
      this.chartDataForRawCertaintyScoreMeanChart = cScores[0];
      this.chartDataForCleanedCertaintyScoreMeanChart = cScores[1];
    }
  }
};
</script>

<template>
  <div class="card" style="border: 1px solid #f5f5f5">
    <div class="card-body">
      <div class="card-title">
        {{ $t("datafileReport.qualityScoresModal.cs.title") }}
      </div>
      <div class="card-text" style="height: 120px;">
        {{ $t("datafileReport.qualityScoresModal.cs.description") }}
      </div>
      <div class="card-text">
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <b-tabs>
              <b-tab active lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.cleaned") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForCleanedCertaintyScoreMeanChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
              <b-tab lazy>
                <template v-slot:title>
                  {{ $t("datafileReport.raw") }}
                </template>
                <div>
                  <apexchart
                    ref="PSMeanChart"
                    class="apex-charts apexChartData"
                    type="radialBar"
                    height="250"
                    dir="ltr"
                    :series="[chartDataForRawCertaintyScoreMeanChart]"
                    :options="meanChartOptions.chartOptions"
                  ></apexchart>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
